import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ElementRef,
  TemplateRef,
  inject,
  input,
  model,
  output,
  signal,
  viewChildren
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';

import { PATH_FILTER_PANEL_PIN } from './path-filter-panel-pin';

let nextId = 0;

/** Docked beside the table rather than over it: the rows re-query live while the filter is edited. */
@Component({
  selector: 'app-path-filter-panel',
  imports: [NgTemplateOutlet, TranslatePipe],
  templateUrl: './path-filter-panel.component.html',
  providers: [
    {
      provide: PATH_FILTER_PANEL_PIN,
      useFactory: () => ({ phrase: signal<TemplateRef<unknown> | null>(null) })
    }
  ],
  styles: `
    :host {
      display: block;
      min-height: 0;
    }
  `
})
export class PathFilterPanelComponent {
  title = input.required<string>();
  entityType = input.required<string>();
  count = input<number | null>(null);
  error = input<string | null>(null);
  /** A CSS length; hosts with more room than a table toolbar widen it. */
  width = input<string>('432px');
  /** The side of the list the panel sits on; its border faces the list. */
  dock = input<'left' | 'right'>('right');
  /** Null for a filter-only host, which keeps its title and single body. */
  tab = model<'filter' | 'sort' | null>(null);

  closed = output<void>();

  protected readonly ICONS = ICONS;
  protected readonly pin = inject(PATH_FILTER_PANEL_PIN, { self: true });
  protected readonly TABS = ['filter', 'sort'] as const;
  private readonly idPrefix = `path-filter-panel-${nextId++}`;
  protected readonly tabpanelId = `${this.idPrefix}-tabpanel`;
  private readonly tabButtons = viewChildren<ElementRef<HTMLButtonElement>>('tabButton');

  protected tabId(option: 'filter' | 'sort'): string {
    return `${this.idPrefix}-tab-${option}`;
  }

  protected onTabKeydown(event: KeyboardEvent): void {
    const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
    const current = this.tab();
    if (step === 0 || current === null) return;
    event.preventDefault();
    const count = this.TABS.length;
    const index = (this.TABS.indexOf(current) + step + count) % count;
    this.tab.set(this.TABS[index]);
    this.tabButtons()[index].nativeElement.focus();
  }
}
